export default "__VITE_ASSET__DamnwxwL__"